<!--  -->
<template>
  <div class="user-container" @click="closeLoginPop">
    <div class="user" @click.stop="noClose">
      <div class="box" v-show="!showRegister">
        <div class="login-pop-title">已有注册账号？</div>
        <div class="nav">
          <div
            class="nav_item"
            :class="{nav_action:showEmail}"
            @click="selectEmailOrPhone(false,'mailFormValidate')"
          >手机号</div>
          <div
            class="nav_item"
            :class="{nav_action:!showEmail}"
            @click="selectEmailOrPhone(true,'formValidate')"
          >邮箱</div>
        </div>
        <Form
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          @on-validate="logOne"
          v-show="!showEmail"
        >
          <FormItem prop="phone">
            <label :class="{form_err:!formErr[0]}">手机号码*</label>
            <Input v-model="formValidate.phone" :autofocus="true" />
          </FormItem>
          <FormItem prop="verifyCode">
            <label :class="{form_err:!formErr[1]}">验证码*</label>
            <Input v-model="formValidate.verifyCode" />
            <div class="code-btn" @click="getCode">{{ verifyCodeText }}</div>
          </FormItem>
          <FormItem class="forget">
            <div class="save">
              <div class="check-box" @click="changeCheckBox('keepSignIn')">
                <img src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202212/83ced1fa0c8f5d0e2ef4e8b87dbfe51a.png" v-if="keepSignIn" />
              </div>
              <div>保持登录状态。</div>
            </div>
            <!--            <div class="forget-password" v-if="!showForgetPassword" @click="forgetPassword">忘记密码？</div>-->
            <!--            <div v-else class="reset-password">-->
            <!--              <Form>-->
            <!--                <div class="label-email">请输入您的电邮地址，我们将发送给您重设密码的邮件。</div>-->
            <!--                <FormItem prop="mail">-->
            <!--                  <label class="lable-email">电邮*</label>-->
            <!--                  <Input v-model="resetEmail" />-->
            <!--                </FormItem>-->
            <!--                <div class="reset-btn">恢复</div>-->
            <!--              </Form>-->
            <!--            </div>-->
          </FormItem>
          <FormItem>
            <div class="btn" @click="login('formValidate')">
              <span class="btn-text">登录</span>
              <img class="btn-lock" src="@/assets/image/icon/lock.svg" />
            </div>
          </FormItem>
        </Form>
        <Form
          ref="mailFormValidate"
          :model="mailFormValidate"
          :rules="ruleValidate"
          @on-validate="logEmail"
          v-show="showEmail"
        >
          <div class="email_tip">由于网站升级不再支持邮箱登录，请老顾客将您的邮箱账号绑定手机号后，通过手机号登录</div>
          <FormItem prop="email">
            <label :class="{form_err:!formErr[5]}">邮箱*</label>
            <Input v-model="mailFormValidate.email" />
          </FormItem>
          <FormItem>
            <div class="btn" @click="sendEmail('mailFormValidate')" style="margin-top: 15px">
              <span class="btn-text">发送邮件</span>
              <img class="btn-lock" src="@/assets/image/icon/lock.svg" />
            </div>
          </FormItem>
          <div class="email_tip" style="margin-top: 14px;" v-if="showEmailOk">已发送邮件至您的邮箱，请前往绑定手机号</div>
        </Form>
        <div class="login-pop-title">注册账号.</div>
        <div class="register-box" @click="changeShowRegister(true,'formValidate')">
          <div class="register-box-text">注册账号</div>
          <img src="@/assets/image/icon/right.svg" />
        </div>
      </div>
      <div class="box" v-show="showRegister">
        <div class="login-pop-title">注册账号.</div>
        <Form
          ref="registerFormValidate"
          :model="registerFormValidate"
          :rules="ruleValidate"
          @on-validate="logTwo"
        >
         <FormItem prop="gender">
            <label :class="{form_err:!formErr[6]}">称谓*</label>
            <Select placeholder="请选择称谓" v-model="registerFormValidate.gender">
               <Option v-for="item in sexList" :value="item.value" :key="item.value">{{ item.name }}</Option>
          </Select>
          </FormItem>
          <div style="overflow: hidden;">
            <FormItem prop="lastName" style="width:48%;float:left;">
            <label :class="{form_err:!formErr[2]}">*姓氏</label>
            <Input v-model="registerFormValidate.lastName" />
            </FormItem>
            <FormItem prop="firstName"  style="width:48%;float:right;">
              <label :class="{form_err:!formErr[7]}">名字*</label>
              <Input v-model="registerFormValidate.firstName" />
            </FormItem>
           </div>
          <!-- <FormItem prop="name">
            <label :class="{form_err:!formErr[2]}">名字*</label>
            <Input v-model="registerFormValidate.name" />
          </FormItem> -->
          <!-- <FormItem class="sex" prop="gender">
            <label>性别*</label>
            <div class="sexs">
              <div class="sex-item">
                <div class="check-box" @click="selectGender(1)">
                  <img src="@/assets/image/icon/close.svg" v-if="registerFormValidate.gender==1" />
                </div>
                <div style="margin-top: 2px">男士</div>
              </div>
              <div class="sex-item" style="margin-left:1rem;">
                <div class="check-box" @click="selectGender(2)">
                  <img src="@/assets/image/icon/close.svg" v-if="registerFormValidate.gender==2" />
                </div>
                <div style="margin-top: 2px">女士</div>
              </div>
            </div>
          </FormItem> -->
          <FormItem prop="phone">
            <label :class="{form_err:!formErr[3]}">手机号码*</label>
            <Input v-model="registerFormValidate.phone" />
          </FormItem>
          <FormItem prop="verifyCode">
            <label :class="{form_err:!formErr[4]}">验证码*</label>
            <Input v-model="registerFormValidate.verifyCode" />
            <div class="code-btn" @click="getRegisterCode">{{ verifyCodeRegisterText }}</div>
          </FormItem>
          <!-- <FormItem class="terms">
            一旦注册即表示您接受并同意遵守我们的
            <span class="term" @click="goRouter('/terms')">条款与条件</span>以及
            <span class="term" @click="goRouter('/privacy')">隐私与COOKIE政策</span>
          </FormItem>
          <FormItem class="forget">
            <div class="save">
              <div
                class="check-box"
                @click="registerFormValidate.subscribePreference=!registerFormValidate.subscribePreference"
              >
                <img
                  src="@/assets/image/icon/close.svg"
                  v-if="registerFormValidate.subscribePreference"
                />
              </div>
              <div>订阅资讯</div>
            </div>
          </FormItem>-->

          <div class="forget-list">
            <FormItem class="forget">
              <div class="save">
                <div
                  class="check-box"
                  @click="registerFormValidate.term1=!registerFormValidate.term1"
                >
                  <img src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202212/83ced1fa0c8f5d0e2ef4e8b87dbfe51a.png" v-if="registerFormValidate.term1" />
                </div>
               <div  class="val">
                若勾选本框，您特此同意收集、使用、披露以及对您个人信息的其他处理，包括但不限于用于<span class="term" @click="goPrivacy">隐私政策</span>所述的直接营销之目的。
                </div>
              </div>
            </FormItem>
            <FormItem class="forget">
              <div class="save">
                <div
                  class="check-box"
                  @click="registerFormValidate.term2=!registerFormValidate.term2"
                >
                  <img src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202212/83ced1fa0c8f5d0e2ef4e8b87dbfe51a.png" v-if="registerFormValidate.term2" />
                </div>
                <div class="val">
                  若勾选本框，您特此同意<span class="term" @click="goPrivacy">隐私政策</span>所述的您的个人信息在中国境外传输、访问、存储及以其他方式的处理。
                </div>
              </div>
            </FormItem>
            <FormItem class="forget" style="margin-top:22px">
              <div class="save">
                <div
                  class="check-box"
                  @click="selectAnalysisConsent"
                >
                  <img src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202212/83ced1fa0c8f5d0e2ef4e8b87dbfe51a.png" v-if="registerFormValidate.allowMarketing==1" />
                </div>
                <div class="val">
                  若勾选本框，您特此同意收集、使用、披露以及对您个人信息的其他处理 市场和营销（包括通过信件等传统方式以及电子邮件、短信或即时信息等电子方式发送信息、邀请、推广活动材料）。
            
                </div>
              </div>
            </FormItem>
          </div>
          <FormItem>
            <div class="btn" @click="register('registerFormValidate')">
              <span class="btn-text">注册</span>
              <img class="btn-lock" src="@/assets/image/icon/lock.svg" />
            </div>
          </FormItem>
        </Form>
        <div class="login-pop-title">已有注册账号？</div>
        <div class="register-box" @click="changeShowRegister(false,'registerFormValidate')">
          <div class="register-box-text">登录</div>
          <img src="@/assets/image/icon/right.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import M from 'minimatch';

export default {
  data() {
    return {
      showEmailOk: false,
      canMail: false,
      showEmail: false,
      formErr: [true, true, true, true, true, true,true,true],
      showRegister: false,
      verifyCodeText: "获取验证码",
      verifyCodeRegisterText: "获取验证码",
      resetEmail: "",
      showForgetPassword: false,
      keepSignIn: true,
      formValidate: {
        phone: "",
        verifyCode: ""
      },
      mailFormValidate: {
        email: ""
      },
      sexList:[
        {
          name:'先生',
          value:1
        },
        {
          name:'女士',
          value:2
        }
      ],
      registerFormValidate: {
        merchantId: this.$store.state.storeId,
        name: "",
        phone: "",
        firstName: "",
        lastName: "",
        verifyCode: "",
        gender: "",
        subscribePreference: false,
        analysisConsent:0,
        term1: false,
        term2: false,
        crossBoarder:0,
        allowMarketing:0
      },
      ruleValidate: {
        gender: [
         {
            required: true,
            message: "此栏为必填项",
            trigger: "change",
            type: 'number'
          }
        ],
        firstName: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          }
        ],
        lastName: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          }
        ],
        verifyCode: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          }
        ],
        mail: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          },
          { type: "email", message: "输入格式有误", trigger: "blur" }
        ],
        email: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          },
          { type: "email", message: "输入格式有误", trigger: "blur" }
        ],
        phone: [
          {
            required: true,
            message: "此栏为必填项",
            trigger: "blur"
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
      }
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.$utils.countingDownVerifyCode(state => {
      this.verifyCodeText = state;
    });
    this.$utils.countingDownVerifyCode2(state => {
      this.verifyCodeRegisterText = state;
    });
  },
  methods: {
    forgetPassword() {
      this.showForgetPassword = true;
    },
    goPrivacy(){
      let routeData = this.$router.resolve({
        path: "/privacy",
      });
      window.open(routeData.href, '_blank');
    },
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (name == "formValidate") {
            this.canLogin = true;
          } else if (name == "mailFormValidate") {
            this.canMail = true;
          } else {
            this.canRegister = true;
          }
        } else {
          if (name == "formValidate") {
            this.canLogin = false;
          } else if (name == "mailFormValidate") {
            this.canMail = false;
          } else {
            this.canRegister = false;
          }
        }
      });
    },
    changeCheckBox(val) {
      this[val] = !this[val];
    },
    selectAnalysisConsent(){
      if(this.registerFormValidate.allowMarketing==1){
        this.registerFormValidate.allowMarketing=0
      }else{
        this.registerFormValidate.allowMarketing=1
      }
    },
    changeShowRegister(val, key) {

      this.$nextTick(() => {
        this.$refs[key].resetFields();
        if (key == "formValidate") {
          this.$refs.mailFormValidate.resetFields();
        }
      });
      this.showRegister = val;
      this.formErr = [true, true, true, true, true, true,true,true];
    },
    selectGender(val) {
      this.registerFormValidate.gender = val;
    },
    async getCode() {
      if (this.verifyCodeText == "获取验证码") {
        this.$refs.formValidate.validateField("phone", err => {
          if (err) {
          } else {
            let url = this.$store.state.API.customer.getVerifyCode;
            this.$http
              .get(url + "?phone=" + this.formValidate.phone)
              .then(res => {
                if (res.status == 200) {
                  if (res.data.result) {
                   
                    this.verifyCodeText = 60;
                    window.localStorage.setItem("countingDown", 60);
                    this.$utils.countingDownVerifyCode(state => {
                      this.verifyCodeText = state;
                    }, true);
                  } else {
                    this.$Message.error(res.data.message);
                  }
                }
              });
          }
        });
      }
    },
    async getRegisterCode() {
      if (this.verifyCodeRegisterText == "获取验证码") {
        this.$refs.registerFormValidate.validateField("phone", err => {
          if (err) {
          } else {
            let url = this.$store.state.API.customer.getVerifyCode;
            let params = { phone: this.registerFormValidate.phone };
            this.$http.get(url + "?" + this.$qs.stringify(params)).then(res => {
              if (res.status == 200) {
                if (res.data.result) {
                
                  this.verifyCodeRegisterText = 60;
                  window.localStorage.setItem("countingDown2", 60);
                  this.$utils.countingDownVerifyCode2(state => {
                    this.verifyCodeRegisterText = state;
                  }, true);
                } else {
                  this.$Message.error(res.data.message);
                }
              }
            });
          }
        });
      }
    },
    register(name) {
      this.handleSubmit(name);
      if (!this.canRegister) {
        return;
      }
      if (!this.registerFormValidate.gender) {
        this.$Message.error("请选择性别");
        return;
      }
      if (!this.registerFormValidate.term2) {
        this.$Message.error("请勾选《隐私政策》协议");
        return;
      }
      if(this.registerFormValidate.term1){
        this.registerFormValidate.analysisConsent =1;
      }
      if(this.registerFormValidate.term2){
        this.registerFormValidate.crossBoarder=1;
      }
      let url = this.$store.state.API.customer.register;
      this.$http.post(url, this.registerFormValidate).then(res => {
        if (res.status == 200) {
        
          if (res.data.result) {
            var data = res.data.returnData.userOfficialWeb;
            var token = res.data.returnData.tb_token;
            this.$utils.setToken(token);
            window.localStorage.setItem("userInfo", JSON.stringify(data));
            this.$store.commit("resetUserInfo", data);
            this.$store.commit("setValue", ["showLoginPop", false]);
            this.$store.commit("setValue", ["userLogin", true]);
            //this.$router.push({ name: "home" });
            this.$gaAction.sign_up(data.phoneNumber);
            this.$router.go(0);
          } else {
            this.$Message.error(res.data.message);
          }
        }
      });
    },
    login(name) {
      this.handleSubmit(name);
      if (!this.canLogin) {
        return;
      }
      let url = this.$store.state.API.customer.login;
      let params = this.formValidate;
      this.$http.get(url + "?" + this.$qs.stringify(params)).then(res => {
        if (res.status == 200) {
       
          if (res.data.result) {
            var data = res.data.returnData.userOfficialWeb;
            var token = res.data.returnData.tb_token;
            this.$utils.setToken(token);
            window.localStorage.setItem("userInfo", JSON.stringify(data));
            this.$store.commit("resetUserInfo", data);
            this.$store.commit("setValue", ["showLoginPop", false]);
            this.$store.commit("setValue", ["userLogin", true]);
            //this.$router.push({ name: "home" });
            this.$gaAction.login(data.phoneNumber);
            this.$router.go(0);
          } else {
            this.$Message.error(res.data.message);
          }
        }
      });
    },
    sendEmail(name) {
      this.handleSubmit(name);
      if (!this.canMail) {
        return;
      }
      let url = this.$store.state.API.customer.sendMail;
      let params = this.mailFormValidate;
      
      this.$http.get(url + "?" + this.$qs.stringify(params)).then(res => {
        if (res.status == 200) {

          if (res.data.result) {
            this.$Message.success("已发送邮件至您的邮箱,请前往绑定手机号");
            this.showEmailOk = true;
          } else {
            this.$Message.error(res.data.message);
          }
        }
      });
    },
    closeLoginPop() {
      this.$store.commit("setValue", ["showLoginPop", false]);
    },
    noClose() {
      return;
    },
    logOne(prop, status, error) {
   
      if (prop == "phone") {
        this.$set(this.formErr, 0, status);
      }
      if (prop == "verifyCode") {
        this.$set(this.formErr, 1, status);
      }
    },
    logEmail(prop, status, error) {
     
      if (prop == "email") {
        this.$set(this.formErr, 5, status);
      }
    },
    logTwo(prop, status, error) {
     
      if (prop == "name") {
        this.$set(this.formErr, 2, status);
      }
      if (prop == "phone") {
        this.$set(this.formErr, 3, status);
      }
      if (prop == "verifyCode") {
        this.$set(this.formErr, 4, status);
      }
      if (prop == "lastName") {
        this.$set(this.formErr, 2, status);
      }
      if (prop == "firstName") {
        this.$set(this.formErr, 7, status);
      }
      if (prop == "gender") {
       
       this.$set(this.formErr, 6, status);
     }
    },
    selectEmailOrPhone(val, key) {

      this.$nextTick(() => {
        this.$refs[key].resetFields();
      });
      this.showEmail = val;
      this.formErr = [true, true, true, true, true, true];
    }
  }
};
</script>
<style scoped lang='less'>
/* @import url(); 引入css类 */
@import "../../assets/style/login.less";
.form_err {
  color: #d0021b !important;
}
.user-container {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  min-height: calc(100vh - 6.6rem);
  display: flex;
  justify-content: center;
  align-items: center;
  .user {
    width: 40rem;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    .box {
      margin-top: 0 !important;
      margin-right: 0 !important;
      padding-top: 3.6rem !important;
      padding-bottom: 5rem !important;
      .login-pop-title {
        font-size: 1.2rem;
        display: flex;
        margin-bottom: 0.8rem;
      }
      .register-box {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 3.4rem;
        border: 0.1rem solid #5c5d5f;
        padding: 0 2rem;
        margin-top: 2rem;
        .register-box-text {
          font-size: 1.2rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #5c5d5f;
        }
        > img {
          width: 0.7rem;
          height: 0.9rem;
        }
      }
    }
  }
}
.check-box {
  cursor: pointer;
  margin-right: 1rem;
  width: 2rem;
  height: 2rem;
  border: 0.1rem solid #959595;
  display: flex;
  justify-content: center;
  align-items: center;
  > img {
    width: 1.4rem;
    height: 1.4rem;
  }
}
.code-btn {
  cursor: pointer;
  position: absolute;
  top: 3.3rem;
  right: 1.5rem;
  padding-left: 1.4rem;
  border-left: 0.1rem solid #5c5d5f;
}
.nav {
  display: flex;
  margin-bottom: 20px;
  margin-top: 20px;
  .nav_item {
    cursor: pointer;
  }
  .nav_item:nth-child(2) {
    margin-left: 40px;
  }
  .nav_action {
    color: #cdccd2;
  }
}
.email_tip {
  text-align: left;
  color: #959595;
  margin-top: 40px;
  margin-bottom: 35px;
}
@media screen and (max-width: 768px) {
  .user-container {
    margin-top: 0;
    .user {
      flex-direction: column;
      .box {
        width: 100%;
        border: none;

        .login-title {
          margin-bottom: 2rem;
        }
      }
    }
  }
}
.forget:first-child .ivu-form-item-content .save{
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/loginPop.vue